import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { DialogService } from '../../../services/dialog.service';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
  selector: 'app-dialog-edit-item',
    imports: [
    CommonModule,
    MatLabel,
    MatFormField,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions
  ],
  templateUrl: './dialog-edit-item.component.html',
  styleUrl: './dialog-edit-item.component.scss'
})
export class DialogEditItemComponent {

  private dialogService = inject(DialogService);

  constructor(
    public dialogRef: MatDialogRef<DialogEditItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCrearArchivo() {
    this.dialogService.agregarFile(this.data.node).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  onCrearDirectorio() {
    this.dialogService.agregarDirectorio(this.data.node).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}